import { useCallback, useEffect, useState } from "react";
import {Formik} from "formik";
import {Button, Form} from "react-bootstrap";
import NotesApi from "../api/NotesApi";
import Note from "../model/Note";
import FormSelect from "../../core/components/theme/FormSelect";
import CategoriesApi from "../api/CategoriesApi";

import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { CKEditor } from "@ckeditor/ckeditor5-react";
import NoteMenu from "./NoteMenu";
import { useDispatch } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";
import PerfectScrollbar from 'react-perfect-scrollbar'
import NoteFilesList from "./NoteFilesList";
import FormAutoSave from "../../core/components/theme/FormAutoSave";
import TagsSelect from "./tags/TagsSelect";
import Category from "../model/Category";

const editorConfiguration = {
    toolbar: {
        items: [
            'heading','todoList','|',
            'bold','italic','strikethrough','underline','link','bulletedList','numberedList','|',
            'outdent','indent','|',
            'blockQuote','insertTable','horizontalLine'
        ]
    },
    language: 'en',
    table: {
        contentToolbar: ['tableColumn','tableRow','mergeTableCells']
    }
};

export default function NoteForm(props) {
    const dispatch = useDispatch();
    const intl = useIntl();

    const [note, setNote] = useState(null);
    const [categories, setCategories] = useState([]);

    const loadNoteData = useCallback(() => {
        CategoriesApi.getCategories()
        .then(data => {
            setCategories(data.content)
        })
        
        if (props.noteId !== undefined) {
            NotesApi.getNote(props.noteId)
                .then(noteData => {
                    console.log(noteData)
                    setNote(noteData);
                })
        } else {
            setNote(new Note());
        }
    }, [props.noteId]);

    useEffect(()=>{
        loadNoteData();
    }, [loadNoteData])


    const saveNote = (values) => {
        if (values.id) {
            return updateNote(values);
        } else {
            return createNote(values);
        }
    }

    const createNote = (values) => {
        var data = {...values, labels: []};
        return NotesApi.createNote(data)
            .then((newNote) => {
                if (props.onSave !== undefined) {
                    props.onSave(newNote);
                }
            })
    }

    const updateNote = (values) => {
        var data = {...values, labels: []};
        return NotesApi.updateNote(data)
            .then((savedNote) => {
                if (props.onSave !== undefined) {
                    props.onSave(savedNote);
                }
            })
    } 

    const toggleFavorites = (noteId, favorites) => {
        NotesApi.setNoteFavorites(noteId, favorites)
            .then(() => {
                setNote({...note, favorites});
            })
    }

    // const backToNotesList = () => {
    //     toggleClass(".email-content", 'open')
    // }

    // const setViewMode = () => {
    //     dispatch(setNoteViewMode(NOTES_NOTE_MODE.VIEW));
    // }

    return (
        <div className="note note-form h-100 layers">
            {null != note ? <Formik
                enableReinitialize={true}
                initialValues={note}
                validate={values => {
                    const errors = {};
                    if (!values.title) {
                        errors.title = intl.formatMessage({id:"field_required"});
                    }
                    if (!values.content) {
                        errors.content = intl.formatMessage({id:"field_required"});
                    }
                    return errors;
                }}
                onSubmit={(values, { setSubmitting, resetForm }) => {
                    saveNote(values).finally(() => {
                        setSubmitting(false);
                        // resetForm();
                    })
                }}
            >
                {({
                      values, errors, touched,
                      handleChange, handleBlur, handleSubmit,
                      isSubmitting, setFieldValue
                      /* and other goodies */
                  }) => {
                    return (
                        <Form onSubmit={handleSubmit} noValidate={true} className="layer w-100">
                            <div className="bgc-grey-100 peers ai-c jc-sb p-20 fxw-nw ">
                                <div className="peer">
                                    {note.id ?<div className="favorites" onClick={() => toggleFavorites(note.id, !note.favorites)}>
                                        {note.favorites ? <i className="fa-solid fa-star"></i> : <i className="fa-regular fa-star"></i>}
                                    </div> : ""}
                                </div>
                                    
                                
                                <div className="peer">
                                    <Button variant="primary" type="submit" disabled={isSubmitting} className="btn-color">
                                        {!isSubmitting ? <i className="fa-solid fa-check"></i> : ""}
                                        <small style={{ color: "gray", fontSize: 11 }}>
                                            <FormAutoSave debounceMs={300} />
                                        </small>
                                    </Button>

                                    {note.id ? <NoteMenu noteId={Number.parseInt(note.id)}/> : ''}
                                </div>                  
                            </div>
                            <PerfectScrollbar className="layer w-100 fxg-1 pos-r">
                                <div className="email-content-wrapper">
                                    <div className="bdT pX-10 pY-20">
                                        <Form.Group controlId="title">
                                            <Form.Control type="text" placeholder={intl.formatMessage({id:"title"})}
                                                        className="mb-1"
                                                        autoComplete="off"
                                                        name="title"
                                                        onChange={handleChange}
                                                        onBlur={handleBlur}
                                                        value={values.title}/>
                                            {errors.title && touched.title && <Form.Text className="text-danger">
                                                {errors.title}
                                            </Form.Text>}
                                        </Form.Group>

                                        <div className="row g-3 align-items-center mb-1">
                                            <Form.Group controlId="noteCategoryId" className="col-auto">
                                                <select label="Category" name="noteCategoryId" className="form-control" 
                                                        value={values.noteCategory ? values.noteCategory.id : ""}
                                                    onChange={(e) => {
                                                        if(e.target.value) {
                                                            let nc = new Category();
                                                            nc.id = e.target.value
                                                            setFieldValue("noteCategory", nc)
                                                        } else {
                                                            setFieldValue("noteCategory", null)
                                                        }                                                        
                                                    }}>
                                                    <option value="">
                                                        <FormattedMessage id="select_category"/>
                                                    </option>                      
                                                    {categories.map(category => {                            
                                                        return <option value={category.id} key={'select-category-' + category.id}>{category.title}</option>
                                                    })}                            
                                                </select>
                                            </Form.Group>
                                            <Form.Group controlId="tags" className="col-auto">
                                                <TagsSelect
                                                    initialTags={values.tags}
                                                    onChangeTags={(tags) => {  
                                                        setFieldValue("tags", tags)
                                                    }}/>
                                            </Form.Group>
                                        </div>

                
                                        <CKEditor
                                            id="inputText"
                                            className="inputText"
                                            config={ editorConfiguration }
                                            editor={Editor}
                                            data={values.content}
                                            onChange={(event, editor) => {
                                                setFieldValue("content", editor.getData());
                                            }}                                
                                        />
                                    </div>

                                    <div className="note-attachements">
                                        <NoteFilesList editMode={true}
                                                        noteId={note ? note.id : undefined } 
                                                        onChangeFilesList={(filesList) => {
                                                            var fileIds = filesList.map(it => it.id);
                                                            setFieldValue("media", fileIds);
                                                        }}/>
                                    </div>
                                </div>
                            </PerfectScrollbar>
                        </Form>
                    )
                  }}
            </Formik> : ""}
        </div>
    )
}